<template>
  <div>
    <template v-if="$membershipHasPermissionTo('create contact lists')">
      <div class="bg-white p-4 rounded border border-gray-400">
        <BaseButton primary @click="setModalCreateVisible(true)"> Add new </BaseButton>

        <BaseButton primary class="ml-2" @click="setModalLinkExistingVisible(true)">
          Add Existing
        </BaseButton>
      </div>
    </template>

    <ContactLists
      :loading="pending"
      :project-uuid="projectId"
      :contact-lists="contactLists"
      class="mt-4"
      @contact-list-delete="removeContactList"
    />

    <template v-if="$membershipHasPermissionTo('create contact lists')">
      <portal v-if="modalCreateVisible" to="app-dialog">
        <ModalCreate :project-uuid="projectId" @closed="modalCreateVisible = false" />
      </portal>
    </template>

    <template v-if="$membershipHasPermissionTo('create contact lists')">
      <portal v-if="modalLinkExistingVisible" to="app-dialog">
        <ModalLinkExisting
          :account-uuid="$route.params.accountId"
          :project-uuid="projectId"
          @closed="modalLinkExistingVisible = false"
        />
      </portal>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import ContactLists from '@/components/ProjectContactLists/ContactListList.vue';
import ModalCreate from '@/components/ProjectContactLists/ModalCreate.vue';
import ModalLinkExisting from '@/components/ProjectContactLists/ModalLinkExisting.vue';

export default {
  components: {
    ContactLists,
    ModalCreate,
    ModalLinkExisting,
  },

  props: {
    accountId: { type: String, required: true },
    projectId: { type: String, required: true },
  },

  data: () => ({
    pending: false,
    modalCreateVisible: false,
    modalLinkExistingVisible: false,
  }),

  computed: {
    ...mapState('ui/projectContactLists', ['ids']),
    ...mapGetters('ui/projectContactLists', ['contactLists']),
  },

  created() {
    this.init();
  },

  destroyed() {
    this.setIds([]);
    this.setMeta(null);
    this.setLinks(null);
  },

  methods: {
    ...mapActions('ui/projectContactLists', {
      loadContactLists: 'load',
      storeContactList: 'store',
      deleteContactList: 'destroy',
    }),

    ...mapMutations('ui/projectContactLists', ['setIds', 'setMeta', 'setLinks']),

    async init() {
      const { projectId } = this;

      this.pending = true;

      try {
        const { contactListUuids } = await this.loadContactLists({ projectUuid: projectId });

        if (
          contactListUuids.length === 1 &&
          !this.$membershipHasPermissionTo('create contact lists')
        ) {
          this.$router.replace({
            name: 'accounts.contactLists.contactListUuid',
            params: {
              accountId: this.accountId,
              contactListUuid: contactListUuids[0],
            },
          });
        } else {
          this.pending = false;
        }
      } catch (error) {
        this.pending = false;
      }
    },

    setModalCreateVisible(bool) {
      this.modalCreateVisible = bool;
    },

    setModalLinkExistingVisible(bool) {
      this.modalLinkExistingVisible = bool;
    },

    async removeContactList(contactListUuid) {
      const { projectId } = this;

      try {
        await this.deleteContactList({ projectUuid: projectId, contactListUuid });
        this.resetAction();
      } catch (error) {
        //
      }
    },
  },
};
</script>
